/*
 * Application State should be all within this file.
 */

const app = {
  state: {
    example: "demo demo demo" /* Demo only, remove during development */,
    exampleFormFields: {
      value1: "",
      value2: ""
    } /* Demo only, remove during development */
  },
  mutations: {
    SET_EXAMPLE(state, value) {
      /*
       * Demo only, remove during development
       */
      state.example = value;
    },
    SET_EXAMPLE_FORM_FIELDS(state, value) {
      /*
       * Demo only, remove during development
       */
      state.exampleFormFields = value;
    }
  },
  actions: {
    setExample({ commit }, value) {
      /*
       * Demo only, remove during development
       */
      commit("SET_EXAMPLE", value);
    },
    setExampleFormFields({ commit }, values) {
      /*
       * Demo only, remove during development
       */
      commit("SET_EXAMPLE_FORM_FIELDS", values);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        // If payload is not valid JSON, use it as-is
        console.warn("Failed to parse datastore payload as JSON:", e.message);
        _payload = payload;
      }

      /*
       * Call a mutation to put your datastore payload into your app state
       */
      commit("SET_EXAMPLE", _payload?.example ?? state.example);
      commit(
        "SET_EXAMPLE_FORM_FIELDS",
        _payload?.exampleFormFields ?? state.exampleFormFields
      );
    }
  },
  getters: {
    getExample(state) {
      /*
       * Demo only, remove during development
       */
      return state.example;
    },
    getExampleFormFields(state) {
      /*
       * Demo only, remove during development
       */
      return state.exampleFormFields;
    },
    mapToDatastore(state) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */

      let payload = {
        example: state.example,
        exampleFormFields: state.exampleFormFields
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
